<template>
  <div class="flex flex-shrink-0 overflow-y-auto overflow-x-hidden">
    <div
      class="min-h-screen flex flex-col bg-indigo-600 transition-all duration-100 ease-in relative z-20"
      :class="{ 'max-w-max w-72 2xl:w-80': isFullMenu }"
    >
      <div class="h-0 flex-1 flex flex-col pt-10 overflow-y-auto">
        <div @click="$emit('changePage')">
          <router-link
            class="flex items-center flex-shrink-0 px-6"
            :to="{ name: 'Dashboard' }"
            title="Accueil"
          >
            <icon
              name="logo-neopass-dark"
              :class="
                'text-white transition ease-in-out duration-150 ' +
                  (isFullMenu ? '' : 'hidden')
              "
            />
            <icon
              name="logo-neopass-dark-reduce"
              :class="isFullMenu ? 'hidden' : ''"
              label="Accueil"
            />
            <beta-tag v-if="$freeParticulier()" />
          </router-link>
        </div>

        <nav class="mt-16 flex-1">
          <!-- BEGIN List pages allowed -->
          <div
            v-for="page in listPages"
            :key="page.name"
            @click="
              SET_MSGPREMIUM('');
              $emit('changePage');
            "
          >
            <MenuLink
              :page="page"
              :current-page="currentPage"
              :is-full-menu="isFullMenu"
            />
          </div>
          <!-- END List pages allowed -->
        </nav>
      </div>

      <div
        v-if="currentPage === '/' && $can('dashboard_custom')"
        class="flex-shrink-0 flex tour_customizedashboard"
      >
        <router-link
          :to="{ name: 'CustomizeDashboard' }"
          class="my-3 flex items-center py-4 px-6 text-xs focus:outline-none transition ease-in-out duration-150"
        >
          <div
            class="mr-4 p-3 rounded-full bg-indigo-100 border-2 border-pink-600 text-indigo-600 hover:text-indigo-300 focus:text-indigo-300 hover:bg-indigo-600"
          >
            <icon
              name="options"
              class="h-8 w-8 transition ease-in-out duration-150"
            />
          </div>

          <p :class="(isFullMenu ? '' : 'hidden') + ' ml-4 pt-1 text-white'">
            Personnaliser<br>mon dashboard
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from './Icon';
import Popup from './Popup';
import MenuLink from './MenuLink';
import BetaTag from './BetaTag.vue';

export default {
  name: 'MenuDesktop',
  components: {
    MenuLink,
    Icon,
    Popup,
    BetaTag,
  },

  data() {
    return {
      //
    };
  },

  methods: {
    ...mapMutations({
      SET_MSGPREMIUM: 'listMenus/SET_MSGPREMIUM',
    }),
  },
  computed: {
    ...mapGetters({
      isFullMenu: 'listMenus/isFullMenu',
      listPages: 'listMenus/listPages',
      msgPremium: 'listMenus/msgPremium',
    }),

    currentPage() {
      return this.$route.path === '/' ||
        this.$route.path.includes('cartographies/collectives')
        ? this.$route.path
        : this.$route.path.split('/')[1];
    },
  },
};
</script>
